import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcWarning20 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 20,
	viewBox: "0 0 20 20",
	width: 20,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m10 2c.772 0 1.397.436 1.732 1.074l5.907 12.048c.134.302.201.604.201.872 0 1.108-.766 2.006-1.84 2.006h-12c-1.074 0-2-.898-2-2.006 0-.302.067-.604.201-.872l5.974-11.982c.302-.67 1.087-1.14 1.825-1.14zm0 2-6 12h12zm-1 8v-4h2v4zm1 1.007c.548 0 1 .452 1 1 0 .549-.452 1-1 1s-1-.451-1-1c0-.548.452-1 1-1z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcWarning20;
